import React from 'react';
import styles from '../LandingPage.module.css';
import extraStyles from '../LandingPageExtras.module.css';

const EnginesSection = () => {
  return (
    <div className={styles.lightSection}>
      <div className={styles.section} style={{ paddingTop: '40px' }}>
        <div className={styles.pillLight}>🔹 Integrated Ecosystem</div>
        <h2 className={styles.sectionTitleLight}>One ecosystem. Three intelligent engines.</h2>
        <p className={styles.sectionSubtitleLight}>Talent, automation and engineering — unified to operate AI-first Global Capability Centers.</p>
        
        <div className={extraStyles.enginesGrid}>
          <div className={extraStyles.engineCard}>
            <div className={extraStyles.engineIcon}>👥</div>
            <h3>Prohirey</h3>
            <p>AI hiring & talent intelligence platform</p>
          </div>
          
          <div className={extraStyles.engineCard}>
            <div className={extraStyles.engineIcon}>🤖</div>
            <h3>ToxBox AI</h3>
            <p>AI automation & workforce intelligence</p>
          </div>
          
          <div className={extraStyles.engineCard}>
            <div className={extraStyles.engineIcon}>🏢</div>
            <h3>Provaantech</h3>
            <p>Engineering execution & GCC operations</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EnginesSection;
